module.exports = __webpack_public_path__ + "img/hubs.c93fe567.jpg";